// GENERATED from ez-tree preset "Ash Large" — Scripts/EzTree/PresetConverter.js
// Rerun (to see the drift vs. upstream ez-tree): npm start client.eztree.convertPresets
// NOT read-only: hand tweaks are expected; the converter is just the starting point.
//
// Sizing: targetHeight (metres) is THE scale knob — the generator scales the mesh uniformly to
// that height (unset = the root's default). value = rawHeight × ezTreeUnitToMeters, so the preset
// keeps its natural proportions (× 1.1 on value = +10% overall size); `swing` varies the height
// ±its fraction across the kind's variants. Both numbers are meant to be hand-tweaked.
// footprintRadiusRatio = observed width / observed height; resolved footprint radius =
// targetHeight × footprintRadiusRatio (so resizing via targetHeight keeps width proportional).
import {SceneryKindDef} from "../../@SceneryTypes.js";
import {EZTREE_ROOT_KIND_ID} from "../Kind_EzTree.js";

export const AshLarge_KIND_ID = "ezTree_AshLarge";

export const AshLargeKind = new SceneryKindDef({
	id: "ezTree_AshLarge",
	name: "Ash Large",
	baseKindID: EZTREE_ROOT_KIND_ID,
	// Only the flat keys differing from the root's defaults (TreeOptions ctor defaults) are set —
	// everything else inherits the root.
	paramOverrides: {
		"branchAngle1": 39,
		"branchAngle2": 39,
		"branchAngle3": 51,
		"branchChildren0": 10,
		"branchChildren1": 4,
		"branchChildren2": 3,
		"branchGnarliness0": -0.05,
		"branchGnarliness2": 0.16,
		"branchGnarliness3": 0.049999999999999996,
		"branchLength0": 45,
		"branchLength1": 29.42,
		"branchLength2": 15.3,
		"branchLength3": 4.6,
		"branchRadius0": 3.03,
		"branchRadius1": 0.53,
		"branchRadius2": 0.79,
		"branchRadius3": 1.11,
		"branchSections1": 8,
		"branchSections2": 6,
		"branchSections3": 4,
		"branchStart1": 0.32,
		"branchStart2": 0.34,
		"branchStart3": 0,
		"branchTaper1": 0.6199999999999999,
		"branchTaper2": 0.7599999999999999,
		"branchTaper3": 0,
		"branchTwist0": 0.09,
		"branchTwist1": -0.07,
		"leafCount": 10,
		"leafSize": 4.62,
		"leafSizeVariance": 0.72,
		"leafAngle": 30,
		"leafStart": 0.01,
		"leafType": "ash",
		"barkTint": 13552830,
		"barkTextureScaleX": 0.5,
		"barkTextureScaleY": 5,
		"targetHeight": 23.96,
	},
	footprintRadiusRatio: 0.422,
});
